import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { Formik, Form, Field } from "formik";
import { FileUploader } from "react-drag-drop-files";
import Swal from "sweetalert2";
import * as Yup from "yup";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import Label from "designs/v1/components/Label";
import TextInput from "designs/v1/components/TextInput";
import BootstrapModal from "designs/v1/pages/ModifyKyc/components/BootstrapModal";
import {
  getActiveUserAddress,
  updateCommunicationAddress,
  getAddressByPincode,
  verifyCorrespondenceAddress,
  verifyCorrespondenceOtherAddress,
  validateIncomeProof,
  sendDataToKraApi,
  getRequestTypeStage,
  getRequestTypeDocs,
  addAddressKra,
} from "designs/v1/pages/ModifyKyc/services";
import {
  isEmptyObject,
  validateOnNumber,
  validateOnPaste,
  onInputToUpperCase,
  jsonToFormData,
} from "utils";

const addressTypes = [
  { name: "None", value: "" },
  { name: "Aadhaar", value: "Aadhaar" },
  { name: "Voter ID", value: "VoterID" },
  { name: "Passport", value: "Passport" },
  { name: "Driving License", value: "DrivingLicense" },
  { name: "Other", value: "Other" },
];

const FILE_TYPES = ["JPG", "JPEG", "PNG", "PDF"];

const CommunicationAddressForm = ({
  activeUserDetail,
  stageScreen,
  setStageScreen,
  setStep,
  isLoading,
  setIsLoading,
}) => {
  const timeout = useRef();
  const [verifyAddress, setVerifyAddress] = useState(null);
  const [commProof, setCommProof] = useState({
    type: "",
    file1: "",
    file2: "",
    file_type: "Image",
    address_proof_name: "",
    isAddressChanged: true,
  });
  const [showModal, setShowModal] = useState(false);
  const [initialValues, setInitialValues] = useState({
    is_corr_and_perm_address_same: "1",
    communication_address: {
      address_line1: "",
      city: "",
      pincode: "",
      state: "",
      country: "INDIA",
    },
    // permanent_address: {
    //   address_line1: "",
    //   city: "",
    //   pincode: "",
    //   state: "",
    //   country: "INDIA",
    // },
  });
  useEffect(() => {
    if (!verifyAddress) return;
    const loadAddressInfo = async () => {
      setIsLoading(true);
      try {
        const resp = await getAddressByPincode({
          pincode: verifyAddress.pincode,
        });
        const data = resp.data.data;
        setInitialValues({
          ...initialValues,
          communication_address: {
            address_line1: verifyAddress.address_line1,
            pincode: verifyAddress.pincode,
            city: data.DistrictName || "",
            state: data.StateName || "",
            country: "INDIA",
          },
        });
        setIsLoading(false);
      } catch (error) {
        setInitialValues({
          ...initialValues,
          communication_address: verifyAddress,
        });
        setIsLoading(false);
      }
    };
    loadAddressInfo();
  }, [verifyAddress]);

  useEffect(() => {
    loadVerifyAddress();
  }, []);

  const loadVerifyAddress = async () => {
    setIsLoading(true);
    let payload = {
      request_type: stageScreen,
      active_kyc: activeUserDetail.name,
      address_type: localStorage.getItem("AddressRequestType"),
      existing_customer: activeUserDetail.existing_customer,
    };
    try {
      const resp = await getActiveUserAddress(payload);
      setVerifyAddress(resp.data?.data?.active_per_address);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleValidate = (values) => {
    const errors = {};
    if (
      values.is_corr_and_perm_address_same === "0" &&
      (!values.communication_address.address_line1 ||
        !values.communication_address.pincode)
    ) {
      errors.required = "Required";
    }
    if (
      values.is_corr_and_perm_address_same === "0" &&
      !values.communication_address.city &&
      !values.communication_address.state
    ) {
      errors.required = "Required";
    }
    // if (!values.permanent_address.address_line1) {
    //   errors.permanent_address = "Required";
    // }
    // if (!values.permanent_address.pincode) {
    //   errors.permanent_address = "Required";
    // }
    // if (!values.permanent_address.city && !values.permanent_address.city) {
    //   errors.permanent_address = "Required";
    // }
    // if (values.is_corr_and_perm_address_same == "0") {
    //   if (!values.communication_address.address_line1) {
    //     errors.communication_address = "Required";
    //   }
    //   if (!values.communication_address.pincode) {
    //     errors.communication_address = "Required";
    //   }
    //   if (!values.communication_address.city && !values.communication_address.city) {
    //     errors.communication_address = "Required";
    //     errors.communication_address = "Required";
    //   }
    // }
    return errors;
  };

  const handleSubmit = async (value, { resetForm }) => {
    setIsLoading(true);
    let payload = {
      ...value,
      doc_name: localStorage.getItem("AddressRequestNumber"),
      address_type: localStorage.getItem("AddressRequestType"),
      request_type: stageScreen,
    };
    try {
      const resp = await updateCommunicationAddress(payload);
      console.log("resp", resp);
      setIsLoading(false);
      if (resp.data.message?.status_code !== 200) {
        return toast.error(
          resp.data.message?.message || "Internal server error!"
        );
      }
      toast.success(resp.data.message?.message, "Success");
      setShowModal(true);
    } catch (error) {
      const { data } = error.response || {};
      toast.error(data.message || "Internal server error!");
      setIsLoading(false);
    }
  };

  const handleSendDataToKra = async (value) => {
    setIsLoading(true);
    const payload = {
      document_name: localStorage.getItem("AddressRequestNumber"),
      request_type: stageScreen,
      want_to_send_data_to_kra: value === "YES" ? 1 : 0,
    };
    try {
      const resp = await sendDataToKraApi(payload);
      toast.success(resp.data.message?.message, "Success");
      setIsLoading(false);
      handleKra();
    } catch (error) {
      const { data } = error.response || {};
      toast.error(data.message || "Internal server error!");
      setIsLoading(false);
    }
  };

  const handleKra = async (value) => {
    const payload = {
      request_type: stageScreen,
      document_name: localStorage.getItem("AddressRequestNumber"),
      ...value,
    };
    setIsLoading(true);
    try {
      await addAddressKra({
        request_type: stageScreen,
        address_type: localStorage.getItem("AddressRequestType"),
        document_name: localStorage.getItem("AddressRequestNumber"),
        pan_number: activeUserDetail.poi?.[0]?.pan_number,
        dob: activeUserDetail.poi?.[0]?.dob?.split("-").reverse().join("-"),
      });
      setIsLoading(false);
      const requestTypes = getRequestTypeStage();
      const requestTypesDocs = getRequestTypeDocs() || [];
      requestTypesDocs.push(payload.document_name);
      if (requestTypes && requestTypes.length > 0) {
        requestTypes.shift();
        localStorage.setItem("RequestTypeStage", JSON.stringify(requestTypes));
        localStorage.setItem(
          "RequestTypeDocs",
          JSON.stringify(requestTypesDocs)
        );
        Swal.fire({
          title: "Address Modification Request Saved. Thank You..!",
          icon: "success",
          showCloseButton: false,
          showConfirmButton: false,
          timer: 3000,
        });
        if (requestTypes.length === 0) {
          setTimeout(async () => {
            await setStageScreen("MultipleRequestTypes");
          }, 3000);
          return;
        }
        setTimeout(async () => {
          await setStageScreen(requestTypes[0]);
        }, 3000);
        return;
      }
      setStep("AddressModificationReview");
    } catch (error) {
      const { data } = error.response || {};
      toast.error(
        data.message?.message || "Internal server error!"
      );
      setIsLoading(false);
    }
  };

  const getAddressInfo = async (value, setFieldValue, type) => {
    setIsLoading(true);
    let payload = { pincode: value };
    try {
      const resp = await getAddressByPincode(payload);
      const data = resp.data.data;
      setIsLoading(false);
      if (isEmptyObject(data)) return;
      if (type == 1) {
        setFieldValue("permanent_address.city", data.DistrictName);
        setFieldValue("permanent_address.state", data.StateName);
      }
      if (type == 2) {
        setFieldValue("communication_address.city", data.DistrictName);
        setFieldValue("communication_address.state", data.StateName);
      }
    } catch (error) {
      setIsLoading(false);
      if (type == 1) {
        setFieldValue("permanent_address.city", "");
        setFieldValue("permanent_address.state", "");
      }
      if (type == 2) {
        setFieldValue("communication_address.city", "");
        setFieldValue("communication_address.state", "");
      }
    }
  };

  const onSearchPincode = (value, setFieldValue, type) => {
    // 1 for permanent address
    // 2 for communication address
    console.log(type);
    if (type == 1) {
      setFieldValue("permanent_address.pincode", value);
    }
    if (type == 2) {
      setFieldValue("communication_address.pincode", value);
    }
    if (value.length > 5) {
      clearTimeout(timeout.current);
      timeout.current = setTimeout(() => {
        getAddressInfo(value, setFieldValue, type);
      }, 250);
    } else {
      if (type == 1) {
        setFieldValue("permanent_address.city", "");
        setFieldValue("permanent_address.state", "");
      }
      if (type == 2) {
        setFieldValue("communication_address.city", "");
        setFieldValue("communication_address.state", "");
      }
    }
  };

  const getPermanentAddress = (address) => {
    const { city, state } = address;
    let html = [];
    if (city) {
      html.push(
        <span
          key={city}
          style={{ fontSize: "12px", margin: "0 2px" }}
        >
          {city}
        </span>
      );
    }
    if (state) {
      html.push(
        <span
          key={state}
          style={{ fontSize: "12px", margin: "0 2px" }}
        >
          {state}
        </span>
      );
    }
    return html;
  };

  const validateCommunicationProof = () => {
    const { type, file1, file2, address_proof_name } = commProof;
    let valid = false;
    if (
      !type ||
      (type === "DrivingLicense" && !file1) ||
      (type === "Other" && (!address_proof_name || !file1)) ||
      (!["DrivingLicense", "Other"].includes(type) && (!file1 || !file2))
    ) {
      valid = true;
    }
    return valid;
  };

  const uploadCommunicationProof = async (setFieldValue) => {
    const payload = {
      ...commProof,
      doc_name: localStorage.getItem("AddressRequestNumber"),
      existing_customer: activeUserDetail.existing_customer,
    };
    if (
      payload.file1?.type === "application/pdf" ||
      payload.file2?.type === "application/pdf"
    ) {
      payload.file_type = "pdf";
    }
    delete payload["isAddressChanged"];
    setIsLoading(true);
    if (commProof.type === "Other") {
      try {
        const resp = await verifyCorrespondenceOtherAddress(
          jsonToFormData(payload)
        );
        const data = resp.data?.data;
        if (resp.data?.message?.message) {
          toast.success(resp.data.message.message);
        }
        setIsLoading(false);
        setCommProof((prev) => {
          return { ...prev, isAddressChanged: false };
        });
        setFieldValue(
          "communication_address.address_line1",
          data?.corr_address_line1?.toUpperCase() ?? ""
        );
        onSearchPincode(data?.corr_pincode || "", setFieldValue, 2);
      } catch (error) {
        const { data } = error.response || {};
        toast.error(data.message || "Internal server error!");
        setIsLoading(false);
        setCommProof((prev) => {
          return { ...prev, isAddressChanged: false };
        });
      }
    } else {
      delete payload["address_proof_name"];
      try {
        const resp = await verifyCorrespondenceAddress(jsonToFormData(payload));
        const data = resp.data?.data;
        setIsLoading(false);
        setCommProof((prev) => {
          return { ...prev, isAddressChanged: false };
        });
        setFieldValue(
          "communication_address.address_line1",
          data?.corr_address_line1?.toUpperCase() ?? ""
        );
        onSearchPincode(data?.corr_pincode || "", setFieldValue, 2);
      } catch (error) {
        const { data } = error.response || {};
        toast.error(data.message || "Internal server error!");
        setIsLoading(false);
        setCommProof((prev) => {
          return { ...prev, isAddressChanged: false };
        });
      }
    }
  };

  const resetFileField = (name) => {
    setCommProof((prev) => ({ ...prev, [name]: "" }));
  };

  const handleFile = async (name, file) => {
    if (!file) {
      return resetFileField(name);
    }
    const allowed_types = ["image/png", "image/jpeg", "application/pdf"];
    if (!allowed_types.includes(file.type)) {
      resetFileField(name);
      return toast.error(
        "Only Images/Pdf are allowed ( JPG | PNG | PDF )",
        "Error"
      );
    }
    const fileSize = file.size / 1024 ** 2;
    if (fileSize >= 4) {
      resetFileField(name);
      return toast.error("Error: Please upload a file smaller than 4 MB");
    }
    if (file.type === "application/pdf") {
      setIsLoading(true);
      try {
        const resp = await validateIncomeProof(jsonToFormData({ file }));
        const isEncrypted = resp.data?.message;
        if (isEncrypted) {
          resetFileField(name);
          toast.error("Please upload a file without password protected.");
        } else {
          setCommProof((prev) => ({ ...prev, [name]: file }));
        }
        setIsLoading(false);
      } catch (error) {
        resetFileField(name);
        setIsLoading(false);
        toast.error("Internal server error!");
      }
    } else {
      const img = new Image();
      img.src = window.URL.createObjectURL(file);
      img.onload = async () => {
        if (img.width >= 400 && img.height >= 350) {
          setCommProof((prev) => ({ ...prev, [name]: file }));
        } else {
          resetFileField(name);
          return toast.error(
            `The image you uploaded is of lower resolution. Please upload a higher resolution image.`
          );
        }
      };
    }
  };

  return (
    <React.Fragment>
      <Title title="Update Correspondence Address" />
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <div className="mb-2">
              <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validate={handleValidate}
                onSubmit={handleSubmit}
              >
                {({ values, isValid, dirty, isSubmitting, setFieldValue }) => (
                  <Form>
                    <div>
                      <div className="form-group my-2">
                        <p className="m-0 p-0">Correspondence Address</p>
                        <p
                          className="m-0 p-0"
                          style={{ fontSize: "12px" }}
                        >
                          Is correspondence address same as Permanent Address*
                        </p>
                      </div>
                      <div
                        className="form-check form-check-inline"
                        style={{ paddingLeft: 0 }}
                      >
                        <Field
                          type="radio"
                          name="is_corr_and_perm_address_same"
                          value="1"
                          checked={values.is_corr_and_perm_address_same === "1"}
                          onChange={() => {
                            setFieldValue("is_corr_and_perm_address_same", "1");
                            setFieldValue("communication_address", {
                              address_line1: verifyAddress?.address_line1,
                              pincode: verifyAddress?.pincode,
                              city: verifyAddress?.city,
                              state: verifyAddress?.state,
                              country: verifyAddress?.country,
                            });
                            handleValidate({
                              communication_address: {
                                address_line1: verifyAddress?.address_line1,
                                pincode: verifyAddress?.pincode,
                                city: verifyAddress?.city,
                                state: verifyAddress?.state,
                                country: verifyAddress?.country,
                              },
                              is_corr_and_perm_address_same: "1",
                            });
                          }}
                        />
                        <label className="form-check-label mx-1">Yes</label>
                      </div>
                      <div
                        className="form-check form-check-inline"
                        style={{ paddingLeft: 0 }}
                      >
                        <Field
                          type="radio"
                          name="is_corr_and_perm_address_same"
                          value="0"
                          checked={values.is_corr_and_perm_address_same === "0"}
                          onChange={() => {
                            setFieldValue("is_corr_and_perm_address_same", "0");
                            setFieldValue("communication_address", {
                              address_line1: "",
                              pincode: "",
                              city: "",
                              state: "",
                              country: "INDIA",
                            });
                            handleValidate({
                              communication_address: {
                                address_line1: "",
                                pincode: "",
                                city: "",
                                state: "",
                                country: "INDIA",
                              },
                              is_corr_and_perm_address_same: "0",
                            });
                          }}
                        />
                        <label className="form-check-label mx-1">No</label>
                      </div>
                    </div>
                    <div className="card p-2">
                      <p>Correspondence Address</p>

                      {values.is_corr_and_perm_address_same === "0" && (
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-md-6">
                              <Label
                                label="Address Type*"
                                className="my-2"
                              />
                              <select
                                name="type"
                                className="form-select mt-2"
                                onChange={({ target }) => {
                                  setCommProof((prev) => ({
                                    ...prev,
                                    type: target.value,
                                    file1: "",
                                    file2: "",
                                    address_proof_name: "",
                                    isAddressChanged: true,
                                  }));
                                  setFieldValue(
                                    "communication_address.address_line1",
                                    ""
                                  );
                                  onSearchPincode("", setFieldValue, 2);
                                }}
                              >
                                {addressTypes.map((option) => {
                                  return (
                                    <option
                                      key={option.name}
                                      value={option.value}
                                    >
                                      {option.name}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                          {commProof.type && commProof.type === "Other" && (
                            <div className="row mb-1">
                              <div className="col-md-6">
                                <TextInput
                                  label="Proof Type*"
                                  className="form-control mt-2"
                                  value={commProof.address_proof_name}
                                  onChange={({ target }) =>
                                    setCommProof((prev) => ({
                                      ...prev,
                                      address_proof_name: target.value,
                                    }))
                                  }
                                />
                              </div>
                            </div>
                          )}
                          <div className="row">
                            <div className="col-md-6">
                              <div className="d-flex align-items-center justify-content-between">
                                <Label
                                  label="Front Image (jpg, png, pdf)*"
                                  className="my-2"
                                />
                                <div className="file_limit_text">
                                  Maximum file size: 4 MB
                                </div>
                              </div>
                              <div className="file-uploader-container">
                                <FileUploader
                                  key={commProof.type}
                                  handleChange={(file) =>
                                    handleFile("file1", file)
                                  }
                                  name="file"
                                  types={FILE_TYPES}
                                />
                              </div>
                              {/* <input
                                key={commProof.type}
                                name="file1"
                                type="file"
                                accept="image/*,application/pdf"
                                className="form-control"
                                onChange={(e) => handleFile("file1", e)}
                              /> */}
                            </div>
                            <div className="col-md-6">
                              <div className="d-flex align-items-center justify-content-between">
                                <Label
                                  label={`Back Image (jpg, png, pdf)${
                                    ["DrivingLicense", "Other"].includes(
                                      commProof.type
                                    )
                                      ? ""
                                      : "*"
                                  }`}
                                  className="my-2"
                                />
                                <div className="file_limit_text">
                                  Maximum file size: 4 MB
                                </div>
                              </div>
                              <div className="file-uploader-container">
                                <FileUploader
                                  key={commProof.type}
                                  handleChange={(file) =>
                                    handleFile("file2", file)
                                  }
                                  name="file"
                                  types={FILE_TYPES}
                                />
                              </div>
                              {/* <input
                                key={commProof.type}
                                name="file2"
                                type="file"
                                accept="image/*,application/pdf"
                                className="form-control"
                                onChange={(e) => handleFile("file2", e)}
                              /> */}
                            </div>
                          </div>
                          <div className="mt-4">
                            <Button
                              title="Upload"
                              type="button"
                              disabled={
                                isLoading || validateCommunicationProof()
                              }
                              name="Submit"
                              handleClick={() =>
                                uploadCommunicationProof(setFieldValue)
                              }
                            ></Button>
                          </div>
                        </div>
                      )}
                      <div className="form-group my-2">
                        <label className="py-1">
                          Address <span className="text-danger">*</span>
                        </label>
                        <Field
                          name="communication_address.address_line1"
                          placeholder=""
                          className="form-control"
                          as="textarea"
                          onInput={onInputToUpperCase}
                          disabled={
                            values.is_corr_and_perm_address_same === "1" ||
                            commProof.isAddressChanged
                          }
                        />
                      </div>
                      <div className="form-group my-2">
                        <label className="py-1">
                          Pincode<span className="text-danger">*</span>
                        </label>
                        <Field
                          name="communication_address.pincode"
                          placeholder=""
                          className="form-control"
                          onPaste={validateOnPaste}
                          onKeyPress={validateOnNumber}
                          onChange={({ target }) =>
                            onSearchPincode(target.value, setFieldValue, 2)
                          }
                          maxLength="6"
                          disabled={
                            values.is_corr_and_perm_address_same === "1" ||
                            commProof.isAddressChanged
                          }
                        />
                      </div>
                      <div className="d-flex">
                        {getPermanentAddress(values.communication_address)}
                      </div>
                    </div>
                    {/* {values.is_corr_and_perm_address_same === "0" && ( */}
                    {/* <div className="card p-2 mt-2">
                      <div className="form-group my-2">
                        <label className="py-1">Permanent Address</label>
                        <Field
                          name="permanent_address.address_line1"
                          placeholder=""
                          className="form-control"
                          as="textarea"
                          readOnly
                        />
                      </div>
                      <div className="form-group my-2">
                        <label className="py-1">Permanent Pincode</label>
                        <Field
                          name="permanent_address.pincode"
                          placeholder=""
                          className="form-control"
                          onPaste={validateOnPaste}
                          onKeyPress={validateOnNumber}
                          onChange={({ target }) =>
                            onSearchPincode(target.value, setFieldValue, 1)
                          }
                          maxLength="6"
                          readOnly
                        />
                      </div>
                      <div className="d-flex">
                        {getPermanentAddress(values.permanent_address)}
                      </div>
                    </div> */}
                    {/* )} */}
                    <div className="d-flex form-group my-4">
                      <div className="">
                        <Button
                          title="Back"
                          type="button"
                          handleClick={() => setStep("DematUccForm")}
                        />
                      </div>
                      <div className="mx-2">
                        <Button
                          title="Submit"
                          disabled={!isValid}
                        />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <BootstrapModal
        show={showModal}
        showClose={false}
        title="KRA Request"
        content={"Do you wish to update this correspondence address in KRA?"}
        loading={isLoading}
        handleClose={() => handleSendDataToKra("NO")}
        handleSubmit={() => handleSendDataToKra("YES")}
      />
    </React.Fragment>
  );
};

export default CommunicationAddressForm;
